import React from 'react';
import { graphql } from "gatsby"
import SanityPortableText from "../SanityPortableText";
import Image from "gatsby-plugin-sanity-image"

import Pancake from "./Pancake";
import Container from "../Container";
import PancakeIntro from "../PancakeIntro";

import Card from "../../components/Card"
import Button from "../../components/Button"

import "./Schedule.scss";

const Schedule = props => {

  const { title, text, sessions, theme } = props;

  return (
    <Pancake className="PancakeSchedule" theme={theme}>
      <Container size={sessions?.length < 3 ? "Small" : undefined}>
        <PancakeIntro title={title} text={text} textAlign="Left" />

        <div className="PancakeScheduleSessions">
          {sessions?.length > 0 && sessions.map(session => (
            <Card key={session._key} clickable theme="Light">
              <Card.Title>{session.title}</Card.Title>
              <Card.Content>
                <p><strong>{session.dateTime}</strong></p>
                {session.speakers?.length > 0 && 
                  <>
                    {session.speakers.map(speaker => (
                      <div className="PancakeScheduleSpeaker" key={speaker.name}>
                        <Image
                        {...speaker.image}
                          width={24}
                          height={24}
                          alt={`Avatar of ${speaker.name}`}
                        />
                        {speaker.name}, {speaker.jobtitle}, {speaker.company.name}
                      </div>
                    ))}
                  </>
                }
                {session._rawAbstract?.length > 0 &&
                  <div className="PancakeScheduleAbstract">
                    <SanityPortableText blocks={session._rawAbstract} />
                  </div>
                }
              </Card.Content>
              {session.callToAction.label &&
                <Card.CTA>
                  <Button className={`corporate-light full`} to={session.callToAction.url}>{session.callToAction.label}</Button>
                </Card.CTA>
              }
            </Card>
          ))
          }
        </div>
      </Container>
    </Pancake>
  );
}

export const query = graphql`
  fragment SanityPancakeSchedule on SanitySchedule {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    theme
    sessions {
      dateTime
      title
      speakers {
        name
        jobtitle
        company {
          name
        }
        image {
          ...ImageWithPreview
        }
      }
      callToAction {
        label
        url
      }
      _rawAbstract
      _key
    }
  }
`

export default Schedule;